import React from 'react';
import axios from 'axios'
import { useState ,useEffect} from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import {Buffer} from 'buffer';
import { useNavigate } from "react-router-dom";
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`
function Control() {
    const [data,setData] = useState([])
    const navigate = useNavigate();
    const parseData = async()=>{
        const result = await axios(`${SERVER}/api/control`);
        
        setData(result.data);
    
      }
      useEffect(() => {
        parseData()
      }, []);
      
      const approve = async(data) =>{
       const result = await axios.post(`${SERVER}/api/approve`,data)

       alert("Succeed")
       navigate('/')
      }
      
      const deleteUser = async(id) =>{
        const result = await axios.post(`${SERVER}/api/delete/temp`,{id:id})
        alert("Succeed")
        navigate('/')
        }

        useEffect(() => {
            parseData()
          }, [navigate]);
          
    return (
        <div style={{alignItems:'center'}}>
            {data.map((el)=>(
                <Card style={{ width: '50%',margin: 'auto'}}>
             <Card.Img variant="top" src={`data:${el.type};base64,${new Buffer(el.data).toString('base64')}`} style={{width:"100%",margin:'auto',marginTop:'2%'}}/>
                <Card.Body>
                    <Card.Title>{el.firstName} {el.lastName}</Card.Title>
                    <Card.Text>
                    Volunteer in {el.country}
                    </Card.Text>
                    <Button variant="danger" style={{marginRight:'2%'}} onClick={()=>deleteUser(el.id_user_fk)}>DELETE</Button>
                    <Button variant="primary" onClick={()=>approve(el)}>APPROVE</Button>
                </Card.Body>
                </Card>
            ))}
             
        </div>
    );
}

export default Control;